import { motion } from "framer-motion";
import { Star, Gauge } from "lucide-react";

const REVIEWS = [
  {
    name: "Dan M.",
    car: "BMW M340i G20",
    gain: "374 → 442 BHP",
    text: "The car is unrecognisable. Pulls relentlessly from 2,000 rpm and the gearbox map makes it feel factory. Best money I have spent on the car.",
  },
  {
    name: "Sophie R.",
    car: "VW Golf R Mk8",
    gain: "320 → 386 BHP",
    text: "Booked online, car was in and out in half a day with a full dyno printout. The mid-range shove is addictive and motorway economy actually improved.",
  },
  {
    name: "Jay K.",
    car: "Ford Focus ST Mk4",
    gain: "280 → 331 BHP",
    text: "Proper professionals. Talked me through every safety limit, data-logged the car after the map, and the pops and bangs option is pure theatre.",
  },
];

export const Testimonials = () => (
  <section id="reviews" className="relative py-24 sm:py-32 border-t border-[#1F232D]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-14 flex flex-wrap items-end justify-between gap-6"
      >
        <div>
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-nitro mb-4 flex items-center gap-3">
            <span className="inline-block w-10 h-px bg-nitro" />
            Proven on the road
          </p>
          <h2 className="font-heading font-bold uppercase text-4xl sm:text-5xl leading-[0.95] text-neutral-100">
            Drivers, <span className="text-outline">dyno sheets,</span> results
          </h2>
        </div>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            data-testid={`testimonial-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.14, ease: [0.16, 1, 0.3, 1] }}
            className="glass-panel rounded-2xl p-7 flex flex-col hover:border-nitro/50 transition-colors duration-300"
          >
            <div className="flex gap-1 mb-4">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={15} className="fill-nitro text-nitro" />
              ))}
            </div>
            <blockquote className="text-sm text-neutral-300 leading-relaxed flex-1">
              “{r.text}”
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-[#1F232D] flex items-center justify-between">
              <div>
                <p className="font-heading font-semibold uppercase tracking-wide text-neutral-100">
                  {r.name}
                </p>
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-500 mt-1">
                  {r.car}
                </p>
              </div>
              <span className="flex items-center gap-1.5 font-mono text-[10px] tracking-widest text-nitro border border-nitro/40 rounded-full px-3 py-1.5 bg-nitro/10">
                <Gauge size={12} /> {r.gain}
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
